/**
 * 이 요소만 인쇄한다. 복사본을 body 바로 아래(#print-root)에 두고 나머지 화면은 인쇄에서 뺀다.
 * 대화상자 안의 내용이나 긴 화면 아래쪽 내용도 첫 장 맨 위부터 나온다(스타일은 design-v4.css 의 body.printing).
 */
export function printElement(el: Element | null) {
  if (!el) { window.print(); return; }
  document.getElementById('print-root')?.remove();
  const root = document.createElement('div');
  root.id = 'print-root';
  root.append(el.cloneNode(true));
  document.body.append(root);
  document.body.classList.add('printing');
  const done = () => { root.remove(); document.body.classList.remove('printing'); window.removeEventListener('afterprint', done); };
  window.addEventListener('afterprint', done);
  window.print();
}
